import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
//import { Ng4LoadingSpinnerModule } from 'ng4-loading-spinner';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { IPublicClientApplication, PublicClientApplication, InteractionType, BrowserCacheLocation, LogLevel } from '@azure/msal-browser';
import { MsalGuard, MsalInterceptor, MsalBroadcastService, MsalInterceptorConfiguration, MsalModule, MsalService, MSAL_GUARD_CONFIG, MSAL_INSTANCE, MSAL_INTERCEPTOR_CONFIG, MsalGuardConfiguration } from '@azure/msal-angular';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NavMenuComponent } from './nav-menu/nav-menu.component';
import { APP_BASE_HREF } from '@angular/common';
import { CompareService } from './compare/compare.service';
import { BuildListService } from './buildlist/buildlist.service';
import { BatchBranchService } from './batchbranch/batchbranch.service';
import { CommittrackerComponent } from './committracker/committracker.component';
import { CommitTrackerService } from './committracker/committracker.service';
import { CodeCoverageComponent } from './codecoverage/codecoverage.component';
import { CodeCoverageService } from './codecoverage/codecoverage.service';
import { HomeComponent } from './home/home.component';
import { CounterComponent } from './counter/counter.component';
import { FetchDataComponent } from './fetch-data/fetch-data.component';
import { CompareComponent } from './compare/compare.component';
import { CommitComponent } from './commit/commit.component';
import { CompareGridComponent } from './compare/compare-grid/compare-grid.component';
import { UpdateGridComponent } from './compare/update-grid/update-grid.component';
import { FooterComponent } from './footer/footer.component';
import { BuildlistComponent } from './buildlist/buildlist.component';
import { SaveListComponent } from './compare/save-list/save-list.component';
import { ItemGridComponent } from './buildlist/item-grid/item-grid.component';
import { BatchbranchComponent } from './batchbranch/batchbranch.component';
import { CheckboxgroupComponent } from './shared/checkboxgroup/checkboxgroup.component';
import { DbComponent } from './db/db.component';
import { SelectBuildsComponent } from './shared/select-builds/select-builds.component';
import { DbGridComponent } from './db/db-grid/db-grid.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerModule } from "ngx-spinner";
import { AppLinksComponent } from './applinks/applinks.component';
import { OAuthSettings } from '../oauth';
import { ServerinfoComponent } from './serverinfo/serverinfo.component';
import { DebugToolsComponent } from './debugtools/debugtools.component';
import { SearchPipe } from './search.pipe';

const isIE = window.navigator.userAgent.indexOf("MSIE ") > -1 || window.navigator.userAgent.indexOf("Trident/") > -1;


export function loggerCallback(logLevel: LogLevel, message: string) {
  console.log(message);
}

export function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: OAuthSettings.appId, 
      authority: OAuthSettings.authority, 
      redirectUri: '/',
      postLogoutRedirectUri: '/'
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage,
      storeAuthStateInCookie: isIE, // set to true for IE 11
    },
    system: {
      loggerOptions: {
        loggerCallback,
        logLevel: LogLevel.Info,
        piiLoggingEnabled: false
      }
    }
  });
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, Array<string>>();
  protectedResourceMap.set('https://graph.microsoft.com/v1.0/me', ['user.read']); // Prod environment. Uncomment to use.

  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap
  };
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return { interactionType: InteractionType.Redirect };
}

@NgModule({
  declarations: [
    AppComponent,
    NavMenuComponent,
    HomeComponent,
    CounterComponent,
    FetchDataComponent,
    CompareComponent,
    CommitComponent,
    CompareGridComponent,
    UpdateGridComponent,
    FooterComponent,
    BuildlistComponent,
    SaveListComponent,
    ItemGridComponent,
    BatchbranchComponent,
    CheckboxgroupComponent,
    DbComponent,
    SelectBuildsComponent,
    DbGridComponent,
    AppLinksComponent,
    ServerinfoComponent,
    DebugToolsComponent,
    CommittrackerComponent,
    CodeCoverageComponent,
    SearchPipe
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    AppRoutingModule,
    //Ng4LoadingSpinnerModule,
    BrowserAnimationsModule,
    NgbModule,
    NgxSpinnerModule,
    MsalModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true
    },
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory
    },
    {
      provide: MSAL_GUARD_CONFIG,
      useFactory: MSALGuardConfigFactory
    },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: MSALInterceptorConfigFactory
    },
    MsalService,
    MsalGuard,
    MsalBroadcastService,
    CompareService, BuildListService, BatchBranchService, CommitTrackerService, CodeCoverageService, { provide: APP_BASE_HREF, useValue: '/' }],
  bootstrap: [AppComponent]
})
export class AppModule { }
